module.exports = __webpack_public_path__ + "static/pattern-bg-f8cbe9866f881976d2a622b083568570.jpg";